"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Tiny Events class
 *
 * - One `Events` has one type
 * - Each event  handler has one object
 */
var Events = /** @class */ (function () {
    function Events() {
        this.listeners = [];
        this.listenersOnce = [];
    }
    Events.prototype.addEventListener = function (listener) {
        var _this = this;
        this.listeners.push(listener);
        return function () { return _this.removeEventListener(listener); };
    };
    Events.prototype.addEventListenerOnce = function (listener) {
        this.listenersOnce.push(listener);
    };
    Events.prototype.removeEventListener = function (listener) {
        var callbackIndex = this.listeners.indexOf(listener);
        if (callbackIndex !== -1) {
            this.listeners.splice(callbackIndex, 1);
        }
    };
    Events.prototype.removeAllEventListeners = function () {
        this.listeners = [];
        this.listenersOnce = [];
    };
    Events.prototype.emit = function (payload) {
        /** Update any general listeners */
        this.listeners.forEach(function (listener) { return listener(payload); });
        /** Clear the `once` queue */
        if (this.listenersOnce.length > 0) {
            this.listenersOnce.forEach(function (listener) { return listener(payload); });
            this.listenersOnce = [];
        }
    };
    return Events;
}());
exports.Events = Events;
//# sourceMappingURL=Events.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/almin/lib/src/Events.js
// module id = 55
// module chunks = 0